export default {
  error: require('./error.png')
}
